import React from 'react';
import { connect } from 'react-redux';
import { List } from 'react-toolbox/lib/list';
import {
  selectModule,
  showMoreModules,
} from 'manage-modules/redux/manageModulesActions';
import DrawerLayout from 'components/DrawerLayout';
import ListItemCountLabel from 'components/ListItemCountLabel';
import MediaListItem from 'components/MediaListItem';
import SeeMoreListItemsButton from 'components/SeeMoreListItemsButton';
import ModulesDrawerFilterInput from 'manage-modules/components/ModulesDrawerFilterInput';

const ModulesDrawer = ({
  isNewModuleCard,
  itemCount,
  onSelected,
  onShowMore,
  selectedModuleId,
  visibleModules,
}) =>
  <DrawerLayout
    header={
      <div>
        <ModulesDrawerFilterInput />
        <ListItemCountLabel itemCount={itemCount} itemTypes="Modules" />
      </div>
    }
  >
    <List selectable ripple>
      {visibleModules.map(module =>
        <MediaListItem
          key={module.id}
          media={module}
          onSelected={onSelected}
          selected={selectedModuleId === module.id}
          singleSelect={true}
        />,
      )}
    </List>
    {itemCount > visibleModules.length &&
      <SeeMoreListItemsButton onClick={onShowMore} />}
  </DrawerLayout>;

const mapStateToProps = state => {
  const { moduleCard, modulesDrawer } = state.manageModules;
  const { itemCount, selectedModuleId, visibleModules } = modulesDrawer;

  return {
    itemCount,
    isNewModuleCard: moduleCard.isNew,
    selectedModuleId,
    visibleModules,
  };
};

const mapDispatchToProps = dispatch => ({
  onSelected: (selected, moduleId) => {
    dispatch(selectModule(moduleId));
  },
  onShowMore: () => dispatch(showMoreModules()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModulesDrawer);
